var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJokerProLotto4DIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9895 37.926L24.613 29.05M24.613 29.05L20.2205 32.9438L21.2163 16.3712L30.3635 30.226L24.613 29.05ZM21.666 3.9375V7.875M31.8755 8.1655L29.0913 10.9497M36.1035 18.375H32.166M14.2408 25.8003L11.4583 28.5828M11.166 18.375H7.22852M14.2408 10.9497L11.4583 8.16725",
    stroke: "url(#paint0_linear_6578_38255)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6578_38255",
    x1: 12.0134,
    y1: 17.4004,
    x2: 45.3774,
    y2: 39.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBB48E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FBE7C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBB48E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJokerProLotto4DIcon3);
export default __webpack_public_path__ + "static/media/jokerProLotto4dIcon3.668a3da3b65bcdc78bee69d21b8f5377.svg";
export { ForwardRef as ReactComponent };